import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { TabStyles } from '../styles/TabStyles';

const { Sizing, Colors } = TabStyles;

const DividerStyleName = TypeStyle.style({
  border: 'none',
  borderTop: `${Sizing.BorderWidth}px solid ${Colors.L3}`,
  marginBottom: Sizing.ListRowHeight / 2,
  marginLeft: 0,
  marginRight: 0,
  marginTop: Sizing.ListRowHeight / 2,
});

export const MenuDividerWidget: React.FunctionComponent = () =>
  <hr aria-orientation='horizontal' className={DividerStyleName} role='separator' />;
MenuDividerWidget.displayName = 'MenuDividerWidget';
